<template>
  <tr>
    <td>
      {{ item.name }}
    </td>
    <td>
      <div
        v-if="
          $userCheckAccess({
            abilities: 'edit_document_types',
          })
        "
        class="buttons"
      >
        <WorkDocsDocumentTypeModal :create="false" :id="item.id" />
        <DeleteModal
          :item="item"
          :text="
            localStorage.translations.pages['setting-document_type']['dialog_delete'][
              'udalit-tip-dokumenta'
            ] +
            ' ' +
            item.name
          "
        />
      </div>
    </td>
  </tr>
</template>

<script>
import WorkDocsDocumentTypeModal from 'components/setting/workDocsDocumentType/WorkDocsDocumentTypeModal'
import DeleteModal from 'components/DeleteModal'

export default {
  name: 'WorkDocsDocumentTypeTableItem',
  components: { WorkDocsDocumentTypeModal, DeleteModal },
  props: ['item'],
}
</script>
